// 掲載書類編集
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../../BrowserBack';
import { http_status_code_list, maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';
import LoadingModal from '../../../molecules/LoadingModal';
import StaffNavbar from '../../../molecules/StaffNavbar';
import axios from '../../../axios';
import ValidMessage from '../../../atoms/ValidMessage';
import ja from 'date-fns/locale/ja';
import ReactDatePicker from 'react-datepicker';
import PopupStaff from '../../../molecules/PopupStaff';
interface ErrorText {
  subject?: string;
  file_name?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
}
const DisplayedDocumentEdit = () => {
  // ローディング画面表示状態
  const [displayed_documet, setDisplayedDocument] = useState<any>(); //入力値の管理State
  const [is_loading, setIsLoading] = useState(false);
  const [is_confirm, setIsConfirm] = useState<boolean>(false);
  const [error_text, setErrorText] = useState<ErrorText>();
  const [file_name, setFileName] = useState('');
  const [is_popup, setIsPopup] = useState<boolean>(false);
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const id = url_params.get('id');
  const post_data = new FormData();

  // グローバルナビゲーション表示用
  const [role, setRole] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);
  // 組織区分コードの取得
  const node = document.getElementById('displayed-document-edit');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    getDisplayedDocument();
    // グローバルナビゲーション表示用
    setUserRole();
  }, []);

  /**
   * idから該当レコード取得
   * @return Promise<void>
   */
  const getDisplayedDocument = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_displayed_document`,
        {
          params: {
            id: id,
          },
        }
      );
      if (response.data.result) {
        setDisplayedDocument(response.data.list);
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * postするデータを生成
   * @return FormData
   */
  const createPostData = (): FormData => {
    post_data.append('id', displayed_documet.id);
    post_data.append('type', displayed_documet.type);
    post_data.append('subject', displayed_documet.subject);
    post_data.append('description', displayed_documet.description);
    post_data.append('start_date', displayed_documet.start_date);
    post_data.append('end_date', displayed_documet.end_date);
    post_data.append('file', displayed_documet.file);
    post_data.append('file_name', file_name);
    return post_data;
  };

  /**
   * 掲載書類の登録処理
   * @return Promise<void>
   */
  const handleRegister = async (): Promise<void> => {
    setIsLoading(true);
    setErrorText({});
    const post_data = createPostData();
    try {
      const headers = { 'content-type': 'multipart/form-data' };
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/check_displayed_document`,
        post_data,
        { headers }
      );

      if (response.data.result) {
        setIsConfirm(true);
      } else {
        setErrorText({
          subject: response.data.message.subject,
          file_name: response.data.message.file_name,
          description: response.data.message.description,
          start_date: response.data.message.start_date,
          end_date: response.data.message.end_date,
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 確認ボタン押下時
   * @returns Promise<void>
   */
  const handleConfirm = async (): Promise<void> => {
    setIsLoading(true);
    const post_data = createPostData();
    try {
      const headers = { 'content-type': 'multipart/form-data' };
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/register_displayed_document`,
        post_data,
        { headers }
      );

      if (response.data.result) {
        // 編集完了画面に遷移
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents_complete`
        );
      } else {
        setIsLoading(false);
        alert('システムエラーが発生しました');
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 削除ボタン押下時
   * @returns Promise<void>
   */
  const checkDeleteDisplayedDocument = async (): Promise<void> => {
    setIsLoading(true);
    setErrorText({});
    try {
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/check_delete_displayed_document`,
        {
          id: id,
        }
      );
      if (response.data.result) {
        setIsPopup(true);
      } else {
        console.error(response.data.message);
        setErrorText({
          start_date: response.data.message,
        });
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 削除確認ポップアップのOKボタン押下時
   * @returns Promise<void>
   */
  const deleteDisplayedDocument = async (): Promise<void> => {
    setIsLoading(true);
    try {
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/delete_displayed_document`,
        {
          id: id,
        }
      );

      if (response.data.result) {
        // 編集完了画面に遷移
        location.replace(
          `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents_complete`
        );
      } else {
        console.error(response.data.message);
        alert(response.data.message);
        setIsLoading(false);
        setIsPopup(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 編集パラメータに説明文入力、 画面表示名を追加
   * @param event イベントオブジェクト
   * @return void
   */
  const handleChangeEdit = (
    event: React.FormEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    const { name, value } = event.currentTarget;
    setDisplayedDocument({ ...displayed_documet, [name]: value });
  };

  /**
   * 開始日入力
   * @param event イベント
   * @returns void
   */
  const handleChangeStartDate = (value: Date): void => {
    const start_date = conversionDate(value);
    setDisplayedDocument({ ...displayed_documet, start_date: start_date });
  };

  /**
   * 終了日入力
   * @param event イベント
   * @returns void
   */
  const handleChangeEndDate = (value: Date | null): void => {
    if (value === null) {
      setDisplayedDocument({ ...displayed_documet, end_date: '' });
      return;
    }
    const end_date = conversionDate(value);
    setDisplayedDocument({ ...displayed_documet, end_date: end_date });
  };

  /**
   * 日付の変換
   * @param event イベント
   * @returns string
   */
  const conversionDate = (value: Date): string => {
    const year = value.getFullYear();
    const month = value.getMonth() + 1;
    const day = value.getDate();
    return year + '-' + month.toString().padStart(2, '0') + '-' + day.toString().padStart(2, '0');
  };

  /**
   * ファイルを選択した後の処理
   * @param event イベント
   * @returns void
   */
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (
      event === null ||
      event.target === null ||
      event.target.files === null ||
      event.target.files.length <= 0
    ) {
      setFileName('');
      return;
    }
    const file = event.target.files[0];
    setDisplayedDocument({ ...displayed_documet, file: file });
    setFileName(file.name);
  };

  /**
   * 掲載書類編集画面に画面を切り替える
   * @returns void
   */
  const handleClickReturnButton = (): void => {
    setIsConfirm(false);
    setFileName('');
  };

  // ロールを設定する
  const setUserRole = () => {
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }
  };

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <Maintenance active={maintenance_type.displayed_documents}>
        <div className="page-title">
          掲載書類編集
          {is_confirm && '(確認)'}
        </div>
        {typeof displayed_documet === 'object' ? (
          <>
            <table className="detail_table">
              <tbody>
                <tr>
                  <th>JA名</th>
                  <td>{displayed_documet.ja_name}</td>
                </tr>
                <tr>
                  <th>掲載書類</th>
                  <td>{displayed_documet.type_name}</td>
                </tr>
                <tr>
                  <th>画面表示名</th>
                  <td>
                    {is_confirm ? (
                      displayed_documet.subject
                    ) : (
                      <>
                        <input
                          className={`form-control ${error_text?.subject && 'textarea-error'}`}
                          type="text"
                          name="subject"
                          value={displayed_documet.subject}
                          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            handleChangeEdit(event);
                          }}
                        />
                        <ValidMessage message={error_text?.subject} />
                      </>
                    )}
                  </td>
                </tr>
                <tr>
                  <th>ファイル名</th>
                  <td>
                    {is_confirm ? (
                      file_name
                    ) : (
                      <>
                        <td>{file_name ? file_name : displayed_documet?.file_name}</td>
                        <input
                          type="file"
                          className={`form-control ${error_text?.file_name && 'textarea-error'}`}
                          onChange={handleFileSelect}
                        />
                        <ValidMessage message={error_text?.file_name} />
                      </>
                    )}
                  </td>
                </tr>

                <tr>
                  <th>説明文</th>
                  <td>
                    {is_confirm ? (
                      displayed_documet.description
                    ) : (
                      <>
                        <textarea
                          className={`form-control ${error_text?.description && 'textarea-error'}`}
                          rows={3}
                          cols={60}
                          name="description"
                          value={displayed_documet.description}
                          onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                            handleChangeEdit(event);
                          }}
                        />
                        <ValidMessage message={error_text?.description} />
                      </>
                    )}
                  </td>
                </tr>

                <tr>
                  <th>開始日</th>
                  <td>
                    {is_confirm && displayed_documet.start_date ? (
                      displayed_documet.start_date
                    ) : (
                      <>
                        <ReactDatePicker
                          className={`form-control ${error_text?.start_date && 'textarea-error'}`}
                          selected={new Date(displayed_documet.start_date ?? '')}
                          onChange={handleChangeStartDate}
                          locale={ja}
                          dateFormat="yyyy-MM-dd"
                        />
                        <ValidMessage message={error_text?.start_date} />
                      </>
                    )}
                  </td>
                </tr>

                <tr>
                  <th>終了日</th>
                  <td>
                    {is_confirm ? (
                      displayed_documet.end_date
                    ) : (
                      <>
                        <ReactDatePicker
                          className={`form-control ${error_text?.end_date && 'textarea-error'}`}
                          selected={
                            displayed_documet.end_date ? new Date(displayed_documet.end_date) : null
                          }
                          onChange={handleChangeEndDate}
                          locale={ja}
                          dateFormat="yyyy-MM-dd"
                        />
                        <ValidMessage message={error_text?.end_date} />
                      </>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="footer-btn">
              {is_confirm ? (
                <>
                  <div
                    className="btn btn-mini btn-outline-success btn-text-color"
                    onClick={handleClickReturnButton}
                  >
                    戻る
                  </div>
                  <div className="btn btn-mini btn-success" onClick={handleConfirm}>
                    確認
                  </div>
                </>
              ) : (
                <>
                  <a
                    className="btn btn-mini btn-outline-success btn-text-color"
                    href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents_detail?id=${id}`}
                  >
                    キャンセル
                  </a>
                  <div className="btn btn-mini btn-danger" onClick={checkDeleteDisplayedDocument}>
                    削除
                  </div>
                  <div className="btn btn-mini btn-success" onClick={handleRegister}>
                    登録
                  </div>
                </>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
        <LoadingModal show={is_loading} />
        <PopupStaff
          toggleShow={is_popup}
          text={'この掲載書類を削除します。よろしいですか？'}
          btn1_label={'OK'}
          btn1_css={'btn-danger'}
          btn1_func={deleteDisplayedDocument}
          btn2_label={'キャンセル'}
          btn2_css={'btn-outline-success btn-text-color'}
          btn2_func={() => {
            setIsPopup(false);
          }}
        />
      </Maintenance>
    </>
  );
};

if (document.getElementById('displayed-document-edit')) {
  render(<DisplayedDocumentEdit />, document.getElementById('displayed-document-edit'));
}
